/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UpdateMarkupRequest extends models.MarkupDetails {
    getFixupPrototypeFunction() { return UpdateMarkupRequest.fixupPrototype; }

    static newInstance(model: Partial<UpdateMarkupRequest>): UpdateMarkupRequest {
        let obj = Object.assign(new UpdateMarkupRequest(), model);
        UpdateMarkupRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UpdateMarkupRequest>): UpdateMarkupRequest {
        if (!model) return null;
        return UpdateMarkupRequest.newInstance(<UpdateMarkupRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UpdateMarkupRequest) {
        if (!obj) return;

        models.UpdateMarkupRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UpdateMarkupRequest): boolean {
        if (models.MarkupDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, UpdateMarkupRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
